import BigWheel from './BigWheel.vue'

export default BigWheel
